module.exports = __webpack_public_path__ + "static/media/icon_engineering.c138e0ff.svg";